import React from 'react'
import { useTranslation } from 'react-i18next'
import { SkeletonForm } from '@node-space/storybook-components/dist/SkeletonLoader'
import { useVerificationContext } from 'hooks/context/useVerificationContext'
import { FormGetError } from '../_components/FormGetError'
import { StepDescription } from '../_components/StepDescription'
import { useAccountRepCrud } from '../AccountRepresentative/AccountRepresentativeV2/useAccountRepCrud'
import { AppointSignatoryForm } from './components/AppointSignatoryForm'

export const AppointSignatory = () => {
  const { t } = useTranslation()
  const { accountContacts: accountContactsData, submitStep } = useVerificationContext()
  const { data, loading, errors } = useAccountRepCrud(accountContactsData)

  return (
    <>
      <StepDescription paragraphs={[t('verification.appointSignatory.description')]} />
      {loading?.isLoadingForm ? (
        <SkeletonForm name="Appoint signatory" />
      ) : errors?.isFetchingAccountContacts ? (
        <FormGetError />
      ) : (
        <AppointSignatoryForm
          {...data}
          accountContactsList={accountContactsData?.list}
          onContinue={submitStep}
        />
      )}
    </>
  )
}
